export const project = 'fordpersonalizationservice';

export const sending = ({ data, event, preview, win }) => {
	const reportsForEventViewer = [];
	const reportsForNewRelic = [];
	let dataPayload = {};

	if (typeof win.FPS === 'object' && data.libMethod && data.action) {
		const libMethod = win.FPS.lib && win.FPS.lib[data.libMethod];
		const actions = win.FPS.actions && win.FPS.actions[data.action];

		if (typeof libMethod === 'function' && typeof actions !== 'undefined') {
			const {
				uid,
				appId,
				paCode,
				zip,
				year,
				brand,
				nameplate,
				trim,
				returnURL
			} = data;

			switch (data.libMethod) {
				case 'ActionNameplateT3':
					dataPayload = libMethod(
						year,
						brand,
						nameplate,
						paCode,
						actions
					);
					break;
				case 'SpecificVehicleViewT3':
					dataPayload = libMethod(
						uid,
						appId,
						paCode,
						zip,
						year,
						brand,
						nameplate,
						trim,
						returnURL,
						actions
					);
					break;
				default:
					break;
			}

			if (!preview) {
				win.FPS.set([dataPayload]);

				reportsForEventViewer.push({
					clientEventName: data.action,
					payload: dataPayload,
					sender: 'FPS.set'
				});

				reportsForNewRelic.push({
					clientEventName: data.action,
					sender: 'FPS.set'
				});
			}
		}
	}

	if (event !== 'ddc.wstagging.first') {
		return {
			reportsForEventViewer,
			reportsForNewRelic
		};
	}

	return {};
};
